// extracted by mini-css-extract-plugin
export default {"uploadIcon":"MiniLoader_uploadIcon__BRqMa","uploading":"MiniLoader_uploading__SG+li"};